import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Navigate } from 'react-router-dom';

import {
  resetErrorMessage,
  resetSuccessMessage,
} from '../../../../userOnBoarding/actions/actions';
import { isNull } from '../../../../../utils/helper';
import * as types from '../../../../../actions/types';
import '../../../styles/form/guestSummary.css';
import withRouter from './../../../../../withRouter';

interface IState {}

interface IProps {
  dispatch: Dispatch;
  razoResp: any;
  resetErrorMessage: () => void;
  resetSuccessMessage: () => void;
  guestFormDetails: any;
  paymentConfirmDetails: any;
  router: any;
  ratingFormDataDetails: any;
}

class Success extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {}

  componentWillUnmount() {
    this.props.dispatch({
      type: types.RESET_CUSTOM_DATA,
    });
  }

  navigationLink = () => {
    if (this.props.router.params.publicId === 'KLWRLP284e4') {
      return `/p/kl/${this.props.router.params.publicId}/renew/${this.props.router.params.instanceId}`;
    } else {
      return `/p/${
        ['KLWLS550f1', 'KLWLP5OZV'].includes(this.props.router.params.publicId)
          ? 'kl'
          : 'naveenenterprises'
      }/${this.props.router.params.publicId}`;
    }
  };

  handleClose = () => {
    this.props.resetErrorMessage();
    this.props.resetSuccessMessage();
  };

  getCurrentFinancialYear = () => {
    let fiscalyear = '';
    const today = new Date();
    if (today.getMonth() + 1 <= 3) {
      fiscalyear =
        today.getFullYear() -
        1 +
        '-' +
        today.getFullYear().toString().slice(-2);
    } else {
      fiscalyear =
        today.getFullYear() +
        '-' +
        (today.getFullYear() + 1).toString().slice(-2);
    }

    return fiscalyear;
  };

  getOrderNumber = () => {
    const orderPrefix = ['KLWLS550f1', 'KLWLP5OZV', 'KLWRLP284e4'].includes(
      this.props.router.params.publicId
    )
      ? 'BITS'
      : 'L';
    const orderKey = ['KLWLS550f1', 'KLWLP5OZV', 'KLWRLP284e4'].includes(
      this.props.router.params.publicId
    )
      ? '_mo_sub_no'
      : 'order_number';
    const orderNum =
      (this.props.paymentConfirmDetails &&
        this.props.paymentConfirmDetails.data &&
        this.props.paymentConfirmDetails.data[orderKey]) ||
      (this.props.razoResp && this.props.razoResp.orderId);
    return `${orderPrefix}-${orderNum}/${this.getCurrentFinancialYear()}`;
  };

  getEmailID = () => {
    const emailKey = ['KLWLS550f1', 'KLWLP5OZV', 'KLWRLP284e4'].includes(
      this.props.router.params.publicId
    )
      ? 's_email_id'
      : '_mo_customer_email_id';
    return this.props.router.params.publicId === 'KLWRLP284e4'
      ? !isNull(this.props.ratingFormDataDetails) &&
        !isNull(this.props.ratingFormDataDetails.data) &&
        !isNull(this.props.ratingFormDataDetails.data[emailKey])
        ? this.props.ratingFormDataDetails.data[emailKey]
        : ''
      : !isNull(this.props.guestFormDetails) &&
          !isNull(this.props.guestFormDetails[emailKey])
        ? this.props.guestFormDetails[emailKey]
        : '';
  };

  render() {
    if (isNull(this.props.razoResp)) {
      return <Navigate to={this.navigationLink()} replace />;
    }
    return (
      <div id="guest-summary-root">
        <div className="guest-success-wrapper">
          <div className="guest-success-content-wrapper">
            <div className="circle-check-icon">
              <i className="fas fa-check" />
            </div>
            <p className="order-successfull">Order Successfully Placed</p>
            <span className="order-no">Order No: {this.getOrderNumber()}</span>
            <p className="order-email">
              A Confirmation has been sent to {this.getEmailID()}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    razoResp: state.reportReducer.razoResp,
    guestFormDetails: state.reportReducer.guestFormDetails,
    paymentConfirmDetails: state.reportReducer.paymentConfirmDetails,
    ratingFormDataDetails: state.reportReducer.ratingFormDataDetails,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
  ...bindActionCreators(
    {
      resetErrorMessage,
      resetSuccessMessage,
    },
    dispatch
  ),
});

export default connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Success));
